import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { AlgoliaManager } from 'src/app/data/manager/algolia/algolia.manager';
import {LegalManager} from '../../data/manager/legal/legal/legal.manager';

@Injectable({
  providedIn: 'root',
})
export class LegalVm {
  constructor(
    private legalManager: LegalManager,
    private algoliaManager: AlgoliaManager
  ) { }

  getLegalInfo(params): Observable<any> {
    return this.legalManager.getLegalInfo(params);
  }

  getTermsFromAlgolia(properties){
    return this.algoliaManager.getPropertiesAlgolia( properties )
  }
}
